import PropTypes from 'prop-types';

import verificationStatusPropType from './verificationStatusPropType.js';

export default PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    reviewUrl: PropTypes.string,
    verificationStatus: verificationStatusPropType,
});



// WEBPACK FOOTER //
// ./safeTrade/partnerPropTypes.js